(function() {
  'use strict';

  // Check if cart contains inside-dhaka-only products
  function hasInsideDhakaProducts() {
    const items = document.querySelectorAll('[data-inside-dhaka="true"]');
    return items.length > 0;
  }

  // Create and show the location selection modal
  function showLocationModal(callback) {
    const existingModal = document.getElementById('inside-dhaka-modal');
    if (existingModal) existingModal.remove();

    const modal = document.createElement('div');
    modal.id = 'inside-dhaka-modal';
    modal.className = 'inside-dhaka-modal-overlay';
    modal.style.cssText = `
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999999;
      padding: 20px;
    `;

    modal.innerHTML = `
      <div style="
        background: #ffffff;
        border-radius: 14px;
        padding: 36px 28px 28px;
        max-width: 480px;
        width: 100%;
        position: relative;
        box-shadow: 0 10px 35px rgba(0, 0, 0, 0.25);
        text-align: center;
      ">
        <button class="inside-dhaka-modal-close" style="
          position: absolute;
          top: 12px;
          right: 15px;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #888;
          padding: 4px 8px;
          line-height: 1;
        " aria-label="Close modal">✕</button>
        
        <div style="
          width: 54px;
          height: 54px;
          background: #eef7ee;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 16px auto;
          font-size: 26px;
        ">🚚</div>

        <h3 style="
          font-size: 20px;
          font-weight: 700;
          margin: 0 0 8px 0;
          color: #111111;
        ">Where do you want this order delivered?</h3>
        
        <p style="
          font-size: 14px;
          color: #666666;
          margin: 0 0 24px 0;
          line-height: 1.5;
        ">Please select your delivery destination to proceed with checkout.</p>
        
        <div style="
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
        ">
          <button type="button" class="inside-dhaka-inside-btn" style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 20px 14px;
            border: 2px solid #28a745;
            border-radius: 10px;
            background: #f6fff8;
            cursor: pointer;
            transition: all 0.2s ease;
          ">
            <span style="font-size: 28px; margin-bottom: 6px; display: block;">📍</span>
            <span style="font-size: 15px; font-weight: 700; color: #1e7e34;">Inside Dhaka</span>
            <span style="font-size: 12px; color: #555; margin-top: 4px;">Direct Delivery</span>
          </button>
          
          <button type="button" class="inside-dhaka-outside-btn" style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 20px 14px;
            border: 2px solid #e0e0e0;
            border-radius: 10px;
            background: #fafafa;
            cursor: pointer;
            transition: all 0.2s ease;
          ">
            <span style="font-size: 28px; margin-bottom: 6px; display: block;">🌍</span>
            <span style="font-size: 15px; font-weight: 700; color: #333333;">Outside Dhaka</span>
            <span style="font-size: 12px; color: #777; margin-top: 4px;">Other Districts</span>
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    const closeBtn = modal.querySelector('.inside-dhaka-modal-close');
    const insideBtn = modal.querySelector('.inside-dhaka-inside-btn');
    const outsideBtn = modal.querySelector('.inside-dhaka-outside-btn');

    insideBtn.addEventListener('mouseenter', () => {
      insideBtn.style.background = '#e8f7ec';
      insideBtn.style.transform = 'translateY(-2px)';
    });
    insideBtn.addEventListener('mouseleave', () => {
      insideBtn.style.background = '#f6fff8';
      insideBtn.style.transform = 'none';
    });

    outsideBtn.addEventListener('mouseenter', () => {
      outsideBtn.style.borderColor = '#999';
      outsideBtn.style.background = '#f0f0f0';
      outsideBtn.style.transform = 'translateY(-2px)';
    });
    outsideBtn.addEventListener('mouseleave', () => {
      outsideBtn.style.borderColor = '#e0e0e0';
      outsideBtn.style.background = '#fafafa';
      outsideBtn.style.transform = 'none';
    });

    const closeModal = () => {
      modal.remove();
      callback(null);
    };

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    // Inside Dhaka selected -> directly go to /checkout
    insideBtn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.remove();
      callback('inside');
    });

    // Outside Dhaka selected -> directly show sorry modal!
    outsideBtn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.remove();
      callback('outside');
    });
  }

  // Create and show polite sorry explanation modal
  function showSorryModal() {
    const existing = document.getElementById('inside-dhaka-sorry-modal');
    if (existing) existing.remove();

    const sorryModal = document.createElement('div');
    sorryModal.id = 'inside-dhaka-sorry-modal';
    sorryModal.className = 'inside-dhaka-modal-overlay';
    sorryModal.style.cssText = `
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999999;
      padding: 20px;
    `;

    sorryModal.innerHTML = `
      <div style="
        background: #ffffff;
        border-radius: 14px;
        padding: 36px 28px 28px;
        max-width: 480px;
        width: 100%;
        text-align: center;
        box-shadow: 0 10px 35px rgba(0, 0, 0, 0.25);
        position: relative;
      ">
        <button class="inside-dhaka-sorry-close" style="
          position: absolute;
          top: 12px;
          right: 15px;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #888;
          padding: 4px 8px;
          line-height: 1;
        " aria-label="Close">✕</button>

        <div style="
          width: 56px;
          height: 56px;
          background: #fff3f3;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 16px auto;
          font-size: 26px;
          color: #d32f2f;
        ">📍</div>

        <h3 style="
          font-size: 20px;
          font-weight: 700;
          color: #111111;
          margin: 0 0 12px 0;
        ">শুধুমাত্র ঢাকার ভিতরে ডেলিভারি</h3>

        <p style="
          font-size: 14px;
          line-height: 1.7;
          color: #555555;
          margin: 0 0 24px 0;
        ">
          আমরা আন্তরিকভাবে দুঃখিত! আপনার কার্টে থাকা এক বা একাধিক পণ্য সর্বোচ্চ সতেজতা ও আসল স্বাদ বজায় রাখতে <strong>শুধুমাত্র ঢাকার ভিতরে</strong> ডেলিভারির জন্য উপলব্ধ।<br><br>
          দুঃখজনকভাবে, ঢাকার বাইরে এই পণ্যগুলোর ডেলিভারি আমরা দিতে পারছি না। অনুগ্রহ করে <strong>ঢাকার ভিতরে</strong> নির্বাচন করুন অথবা ঢাকা-নির্দিষ্ট পণ্যগুলো কার্ট থেকে সরিয়ে অর্ডারটি সম্পন্ন করুন।
        </p>

        <button type="button" class="inside-dhaka-sorry-btn" style="
          background: #111111;
          color: #ffffff;
          border: none;
          padding: 13px 24px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          width: 100%;
          transition: background 0.2s;
        ">বুঝেছি, কার্ট আপডেট করুন</button>
      </div>
    `;

    document.body.appendChild(sorryModal);

    const closeBtn = sorryModal.querySelector('.inside-dhaka-sorry-close');
    const actionBtn = sorryModal.querySelector('.inside-dhaka-sorry-btn');

    const closeModal = () => sorryModal.remove();
    closeBtn.addEventListener('click', closeModal);
    actionBtn.addEventListener('click', closeModal);
    sorryModal.addEventListener('click', (e) => {
      if (e.target === sorryModal) closeModal();
    });
  }

  // Handle Checkout validation
  function handleCheckoutValidation(e) {
    if (hasInsideDhakaProducts()) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }

      showLocationModal((location) => {
        if (location === 'inside') {
          // Go directly to checkout page
          window.location.href = '/checkout';
        } else if (location === 'outside') {
          // Directly show polite sorry modal
          showSorryModal();
        }
      });
      return false;
    }
    return true;
  }

  // Intercept click on any checkout button using capture phase
  document.addEventListener('click', function(e) {
    const checkoutBtn = e.target.closest('.bls-btn-checkout, [name="checkout"], #checkout, a[href*="/checkout"], .cart__checkout-button');
    if (checkoutBtn) {
      if (!handleCheckoutValidation(e)) {
        return false;
      }
    }
  }, true);

  // Intercept form submissions targeting checkout
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form && (form.id === 'cart' || form.id === 'form-mini-cart' || form.classList.contains('checkout-form') || (form.action && form.action.includes('/cart')))) {
      const submitter = e.submitter;
      if (!submitter || submitter.name === 'checkout' || submitter.classList.contains('bls-btn-checkout') || submitter.id === 'checkout') {
        if (!handleCheckoutValidation(e)) {
          return false;
        }
      }
    }
  }, true);

})();

